import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';

import { LoaderEvent } from './../../shared/message.event';
import { UtilityFunctions } from './../../shared/utility-functions';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';

@Component({
    selector: 'app-enable-popup',
    templateUrl: './enable-popup.component.html',
    styleUrls: ['./enable-popup.component.css'],
    providers: [LoaderEvent],
    exportAs: 'enablePopupObj'
})
export class EnablePopupComponent implements OnInit {
    public disableObj = {
        facility: {},
        days: ''
    };
    @ViewChild('childModal') childModal: ModalDirective;
    private stringConstants = CONSTANT_MESSAGES;
    @Input() message = '';
    @Input() popupTitle;
    @Input() cancleButton;
    @Output() notify = new EventEmitter<boolean>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    @Input() deleteMessage;
    @Output() enableFacilityList = new EventEmitter<any>();

    @Input() facilityList = [];
    private vendor;
    private windowHeight = 350;
    private fgtinpt = 60;
    private btngroup = 60;
    private height: any;
    private enableFacilityListOnCheck = [];
    private popUpMessage = '';
    private utilityFunctions = new UtilityFunctions();
    constructor(private loaderEvent: LoaderEvent) {
        this.height = (this.windowHeight - (this.fgtinpt + this.btngroup)) + 'px';
    }

    public showChildModal(): void {
        try {
            this.enableFacilityListOnCheck = [];
            this.facilityList = this.facilityList.map(function (rec: any) {
                rec.isChecked = false;
                return rec;
            });
            this.childModal.config.backdrop = false;
            this.childModal.config.keyboard = false;
            this.utilityFunctions.setBackGroundBlack();
            this.childModal.show();
        } catch (e) {
            console.log(e);
        }
    }

    public hideChildModal(): void {
        try {
            this.facilityList = this.facilityList.map(function (rec: any) {
                rec.isChecked = false;
                return rec;
            });
            this.utilityFunctions.removeBackGroundBlack();
            this.childModal.hide();
        } catch (e) {
            console.log(e);
        }
    }

    ngOnInit() {
    }
    /**
     * Emits the facility list to enable members
     */
    onClickOk(popUpObj) {
        try {
            if (this.enableFacilityListOnCheck.length === 0) {
                this.popUpMessage = 'Fill details';
                popUpObj.showChildModal();
            } else {
                this.enableFacilityList.emit(this.enableFacilityListOnCheck);
                this.hideChildModal();
            }
        } catch (e) {
            console.log(e);
        }
    }

    onClickCancel() {
        try {
            this.notify.emit(false);
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Add facility in list if it is checked otherwise removed
     */
    enableFacility(e, facility) {
        try {
            if (e.target.checked) {
                this.enableFacilityListOnCheck.push(facility._id);
            } else {
                this.enableFacilityListOnCheck.splice(this.enableFacilityListOnCheck.indexOf(facility._id), 1);
            }
        } catch (e) {
            console.log(e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/member/enable-popup/enable-popup.component.ts